<div class="row text-center">
  <div class="col">
    <div class="header-icon full-icon">
      <svg-email-error-svg></svg-email-error-svg>
    </div>
  </div>
</div>
<app-email-use-screen></app-email-use-screen>